<template>
    <keep-alive>
        <div id="Overviewitem">
            <div id="right">
                <div id="switchingroom">
                    <div class="right-title">
                        <div id="siteswitch">
                            <div id="head">
                                <img :src="$store.state.homeitem.png" alt="" />
                            </div>
                            <div id="siteswitch-title">
                                <h2 id="title-name">
                                    {{ gettitle == "" ? $store.state.homeitem.man : gettitle }}
                                </h2>
                                <!-- 5月18日注销 -->
                                <!-- @handlevalue="handleValue" -->
                                <!-- @fomeitem="fomeitem" -->
                                <!-- @Alljack="Alljack" -->
                                <Switchsite @fomeitem="fomeitem"></Switchsite>
                            </div>
                        </div>
                        <!-- @click="toAll" -->
                        <el-button class="itemBtn" @mouseenter.native="homeitemclick"
                            @mouseleave.native="homeitemclickout" @click="toAll">
                            <img class="el-icon-s-home" :src="Ioimg" alt="" v-if="homeitemall == 1" />
                            <img class="el-icon-s-home" :src="Ioimg" alt="" v-else />

                            <!-- <i class="el-icon-s-home"></i>  -->
                            返回园区总览</el-button>
                    </div>
                    <div id="oC">
                        <p>
                            温度:
                            {{ $store.getters.mqttVal(deviceName + "/" + "Temperature") || "--"}}℃
                        </p>
                        <div></div>
                        <p>
                            湿度:<span>{{$store.getters.mqttVal(deviceName + "/" + "Humidity") || "--"}}%</span>
                        </p>
                    </div>
                    <!-- subLoopUrl{{$store.getters.mqttVal("CX/ZTR14/P")}} -->
                    <div id="electricquantity">
                        <div id="one">
                            <div id="loadrate">
                                <p class="record-item">最大总负载率</p>
                                <!-- <p class="record-op" v-if="isclick > 0">--</p> -->
                                <p class="record-op" :style="
                    'color:' +
                      (Jkfhl <= 10
                        ? '#F5AA00'
                        : Jkfhl <= 80
                        ? '#68D86A'
                        : '#fd4238')
                  ">
                                    <!-- //前端计算负荷率 -->
                                    <!-- {{ load }} -->

                                    {{ isNaN(Jkfhl)?'- -':Jkfhl}}
                                    <span v-if="Jkfhl != '- -'">%</span>

                                    <!-- <span id="nbsp" v-if="fuhelv != '- -'">{{ numer }}</span> -->
                                </p>
                            </div>
                            <div id="loadrate">
                                <p class="record-item">装机总容量</p>
                                <!-- <p class="record-op" v-if="isclick > 0">--</p> -->
                                <div class="record-op">
                                    {{ transformerCapacity }}
                                    <span>kVA</span>
                                    <!-- //变压器数量不显示 -->
                                    <!-- <p class="tran" v-if="transformerNum > 1">
                                        <span class="chen">×</span>{{ transformerNum }}
                                    </p> -->
                                </div>
                            </div>
                            <div id="loadrate">
                                <p class="record-item">电压等级</p>
                                <!-- <p class="record-op" v-if="isclick > 0">--</p> -->
                                <p class="record-op">
                                    {{  breaker}}/0.4
                                    <span>kV</span>
                                </p>
                            </div>
                            <div id="loadrate" v-if="this.$store.state.project.currentProject.projectId ==3">
                                <p class="record-item">框架断路器状态</p>
                                <!-- <p class="record-op" v-if="isclick > 0">--</p> -->
                                <p class="record-op">
                                    -
                                    <span>/</span>
                                    -
                                </p>
                            </div>
                            <div id="loadrate" v-else>
                                <p class="record-item">框架断路器状态</p>
                                <!-- <p class="record-op" v-if="isclick > 0">--</p> -->
                                <p class="record-op">
                                    {{
                    voltageClasses1 == 0 || voltageClasses1
                      ? voltageClasses1
                      : $store.state.homeitem.onestate1
                      ? $store.state.homeitem.onestate1
                      : "-"
                  }}
                                    <span>/</span>
                                    {{
                    voltageClasses2 == 0 || voltageClasses2
                      ? voltageClasses2
                      : $store.state.homeitem.onestate2
                      ? $store.state.homeitem.onestate2
                      : "-"
                  }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="temperature">
                        <div class="clickfalls">
                            <ThreeOrone @transformer="transformer" @tNum="tNum"></ThreeOrone>
                            <div class="checkabc">
                                <div class="temperature-item" v-for="(item, index) in Byq" :key="index">
                                    <b>
                                        <h5>
                                            {{ item.numitem }}:{{
                        $store.getters.mqttVal(num + item.data) ||
                        $store.getters.mqttVal(num + item.data) == 0
                          ? $store.getters.mqttVal(num + item.data)
                          : "--"
                      }}
                                        </h5>
                                    </b>
                                    <div v-if="$store.getters.mqttVal(num + item.data)">℃</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="runningstatus">
                    <div id="list">
                        <h3 id="title">运行状态</h3>
                        <!-- <p>回路名称</p> -->
                        <Overviewitemcomponents @compitem="compitem" ></Overviewitemcomponents>
                    </div>
                    <div id="state">
                        <div id="state-one" v-for="(all, index) in state" :key="index">
                            <div id="activefactors" v-for="item in all" :key="item.id">
                                <p class="record-item">{{ item.class }}</p>
                                <p class="record-st 11" v-if="item.backg" :style="
                                    'color:' +
                                    ($store.getters.mqttVal(mqqttwo + item.data) <= 0.5
                                        ? 'black'
                                        : $store.getters.mqttVal(mqqttwo + item.data) <= 1
                                        ? '#68D86A'
                                        : '#fd4238')
                                ">
                                    {{
                                        $store.getters.mqttVal(mqqttwo + item.data)
                                        ?  Number($store.getters.mqttVal(mqqttwo + item.data)).toFixed(2)
                                        : "--"
                                    }}
                                    <span v-if="item.backg">{{ item.backg }}</span>
                                    <span v-else>{{ item.sign }}</span>
                                </p>

                                <p class="record-st" v-else>
                                    {{
                                        item.numtotal
                                        ? ($store.getters.mqttVal(mqqttwo + item.data))
                                            ?(( $store.getters.mqttVal(mqqttwo + item.data) /
                                            item.numtotal)).toFixed(2)
                                            : "- -"
                                        : ($store.getters.mqttVal(mqqttwo + item.data))
                                        ?( $store.getters.mqttVal(mqqttwo + item.data)).toFixed(2)
                                        : item.nodata
                                        ? item.nodata
                                        : "- -"
                                    }}
                                    <span v-if="item.backg">{{ item.backg }}</span>
                                    <span v-else>{{ item.sign }}</span>
                                </p>
                                <!-- <p>{{item.stor}}<span>{{item.sign}}</span></p> -->
                            </div>
                        </div>
                    </div>
                    <div class="temperature1">
                        三相电流:
                        <div class="temperature-item1">
                            <div class="clay">
                                <h5>
                                    A:
                                    {{
                                    isNaN(Ia)?"--":Ia  
                                    }}
                                </h5>
                                <p v-if="$store.getters.mqttVal(mqqttwo + '/Ia')">A</p>
                            </div>
                            <div class="clay">
                                <h5>
                                    B:
                                    {{
                                        isNaN(Ib)?"--":Ib
                                    }}
                                </h5>
                                <p v-if="$store.getters.mqttVal(mqqttwo + '/Ib')">A</p>
                            </div>
                            <div class="clay">
                                <h5>
                                    C:
                                    {{
                                    isNaN(Ic)?"--":Ic
                                    }}
                                </h5>
                                <p v-if="$store.getters.mqttVal(mqqttwo + '/Ic')">A</p>
                            </div>
                        </div>
                    </div>
                    <div class="temperature2" v-if="this.$store.state.project.currentProject.projectId == 2">
                        <!-- 母排温度(C): -->
                        电缆温度：
                        <div class="temperature-item4">
                            <div class="clay">
                                <h5>
                                    {{isNaN(Temperature)?"--":Temperature}}
                                </h5>
                                <p>
                                    {{$store.getters.mqttVal(mqqttwo + "/Temperature") ? "℃" : ""}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="temperature2" v-else-if="this.$store.state.project.currentProject.projectId != 5">
                        母排温度:
                        <div class="temperature-item2">
                            <div class="clay">
                                <h5>
                                    A:{{isNaN(TemperatureA)?"--":TemperatureA}}
                                </h5>
                                <p>
                                    {{
                                    $store.getters.mqttVal(mqqttwo + "/Temperature_A")
                                    ? "℃"
                                    : ""
                                }}
                                </p>
                            </div>
                            <div class="clay">
                                <h5>
                                    B:{{isNaN(TemperatureB)?"--":TemperatureB}}
                                </h5>
                                <p>
                                    {{
                                        $store.getters.mqttVal(mqqttwo + "/Temperature_B")
                                        ? "℃"
                                        : ""
                                    }} </p>
                            </div>
                            <div class="clay">
                                <h5>
                                    C:{{isNaN(TemperatureC)?"--":TemperatureC}}
                                </h5>
                                <p>
                                    {{
                                        $store.getters.mqttVal(mqqttwo + "/Temperature_C")
                                        ? "℃"
                                        : ""
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <TotalAll></TotalAll>
            </div>
        </div>
    </keep-alive>
</template>
<script>
    //详情
    import Details from "../../../components/accidentManagement/Details";
    import TotalAll from "./totalAll";
    import Switchsite from "../../HomePageOverview/components/Switchsite";
    import {
        chainIndex
    } from "../../../api/linkindex";
    import {
        LOOP_DIAGRAM_DATA_BY_DAY,
        INFLUX_QUERY,
        influx_load,
        influx_workload,
        diagramdaily
    } from "../../../api/power";
    import Overviewitemcomponents from "./Overviewitemcomponents";
    import {
        subscribe,
        unsubscribe,
        subscribeEnvironmentInfo,
    } from "../../../mqtt/index";
    import {
        mapState,
        mapMutations
    } from "vuex";
    //时间
    import ThreeOrone from "./threeOrone";
    import {
        GetSensor
    } from "../../../api/common";
    import "../../../util/time";
    export default {
        name: "Overviewitem",
        props: {
            data: Object,
        },
        data() {
            return {
                Ioimg: require("../../../assets/img/返回园区总览.png"),
                Ioimg1: require("../../../assets/img/ebs.png"),
                //切换31: 1,
                tobobos: "123123123123",
                //  变压器台数
                transformerNum: "",
                //进线断路器状态
                areated: 0,
                //数值
                numerical: "",
                //负荷率
                loadRater: "",
                fuhelv: "",
                values: "",
                //电压等级
                breaker: "",
                transformerCapacity: "", //变压器容量
                voltageClasses1: "-", //进线断路器1
                voltageClasses2: " -", //进线断路器2
                trans: "",
                areaId: 0,
                transformerone: "",
                num: "",
                seat: [],
                clickBocks: 0,
                timeNow: 0, //时间
                homeitemall: 0,
                hour: "", //时间
                // temperature: "", //湿度
                deviceName: "", //温度湿度
                id: 2,
                todaynum: "",
                event: [],
                gettitle: "",
                ck: 0,
                mqqttwo: 0,
                //负荷不平衡
                imbalance: "",
                influxDataLoad:{},
                dailyobj:"",
                state: {
                    one: [{
                            id: 1,
                            class: "功率因数",
                            data: "/PF", //对
                            sign: "",
                            backg: "良",
                        },
                        {
                            id: 2,
                            class: "有功功率",
                            data: "/P", //对
                            sign: "kW",
                            numtotal: 1000,
                        },
                        {
                            id: 3,
                            class: "无功功率",
                            data: "/PR",
                            sign: "kVar",
                            numtotal: 1000,
                        },
                    ],
                },
                Byq: [{
                        id: 1,
                        numitem: "A",
                        data: "/Temperature_A"
                    },
                    {
                        id: 2,
                        numitem: "B",
                        data: "/Temperature_B"
                    },
                    {
                        id: 3,
                        numitem: "C",
                        data: "/Temperature_C"
                    },
                ],
            };
        },

        watch: {


            //变压器温度
            num(n, o) {
                //   console.log(n, o);
                subscribe([n]);
                unsubscribe([o]);
            },
            gettitle(n, o) {
                this.gettitle = n;
            },
            areated(n, o) {
                this.areated = n;
            },
            todaynum(n, o) {
                this.todaynum = n;
                // console.log(n, o);
            },

            loadRater(n, o) {
                this.loadRater = n;
            },
            //13号注释
            "$store.state.homeitem.mqqt": function (n, o) {
                // console.log(this.values)
                subscribe([n]);
                unsubscribe([o]);
            },
            mqqttwo(n, o) {
                // console.log(n, o);
                subscribe([n]);
                this.stateTion()
                unsubscribe([o]);
            },
            // // 5月18号注释
            values(n, o) {
                this.values = n;
                subscribe(n);
                unsubscribe(o);
            },
            tobobos(n, o) {
                this.tobobos = n;
            },
            "$store.state.homeitem.png": function (n, o) {
                // console.log(n, o);
                this.$store.state.homeitem.png = n;
            },
        },
        computed: {
            Jkfhl() {
                // console.log(this.Realtime, this.transformerCapacity,parseFloat(((this.Realtime / this.transformerCapacity / 10)).toFixed(2)))
                let fuhe = parseFloat(((this.dailyobj / this.transformerCapacity / 10)).toFixed(2)) || 0
                fuhe = isFinite(fuhe)?fuhe:'--'
                return fuhe
            },
            Ia() {
                let a = parseFloat((this.$store.getters.mqttVal(this.mqqttwo + "/Ia") * 1).toFixed(2))
                return a
            },
            Ib() {
                let b = parseFloat((this.$store.getters.mqttVal(this.mqqttwo + "/Ib") * 1).toFixed(2))
                return b

            },
            Ic() {
                let c = parseFloat((this.$store.getters.mqttVal(this.mqqttwo + "/Ic") * 1).toFixed(2))
                return c
            },
            Temperature() {
                let t = parseFloat((this.$store.getters.mqttVal(this.mqqttwo + "/Temperature") * 1).toFixed(2))
                return t
            },
            TemperatureA() {
                let A = parseFloat((this.$store.getters.mqttVal(this.mqqttwo + "/Temperature_A") * 1).toFixed(2))
                return A
            },
            TemperatureB() {
                let B = parseFloat((this.$store.getters.mqttVal(this.mqqttwo + "/Temperature_B") * 1).toFixed(2))
                return B
            },
            TemperatureC() {
                let C = parseFloat((this.$store.getters.mqttVal(this.mqqttwo + "/Temperature_C") * 1).toFixed(2))
                return C
            },
            //     //实时负载
            Realtime() {
                if (!this.values) {
                    return;
                } else {
                    if (this.$store.state.project.currentProject.projectId == 3) {
                        let aft = this.values.map(
                            (item) => this.$store.getters.mqttVal(item + "/P") * 1
                        );
                        // console.log(22222222222222);
                        return aft.reduce(
                            (prev, current) => (prev ? prev : 0) + (current ? current : 0),
                            0
                        );
                    } else if (this.$store.state.project.currentProject.projectId == 4) {
                        let aft = this.values.map(
                            (item) => {
                                // console.log(this.$store.getters.mqttVal(item + "/P") * 1,this.$store.state.homeitem.mqqt)
                                return this.$store.getters.mqttVal(item + "/P") * 1
                            }
                        );
                        return aft.reduce(
                            (prev, current) => (prev ? prev : 0) + (current ? current : 0),
                            0
                        );
                    } else {
                        // console.log(3333333333333333, this.tobobos,this.$store.state.homeitem.mqqt);
                        let aft =
                            this.$store.getters.mqttVal(
                                this.$store.state.homeitem.mqqt + "/P"
                            ) * 1;
                        return aft;
                    }
                }
            },

            // //负荷率
            load() {
                if (this.$store.state.project.currentProject.projectId == 2) {
                    if (this.Realtime) {
                        // console.log(33331111111111111111);
                        return (
                            (this.Realtime / 1000 / this.transformerCapacity) *
                            100
                        ).toFixed(2);
                    } else {
                        return "- -";
                    }
                } else {
                    // console.log(222222);
                    if (this.Realtime) {
                        return parseFloat(
                            (
                                (this.Realtime / 1000 / this.transformerCapacity / 2) *
                                100
                            ).toFixed(2)
                        );
                    } else {
                        return "- -";
                    }
                }
            },
            numer() {
                if (this.load <= 10) {
                    return (this.numerical = "过低");
                } else if (this.load <= 80) {
                    return (this.numerical = "正常");
                } else {
                    return (this.numerical = "过高");
                }
            },
        },

        mounted() {
            // console.log(this.$store.getters.mqttVal(num + "/Temperature_A"), num);
            // this.Jkfhl();
            // this.influxdbDataLoadInit();
            this.howtall();
            this.transformer();
            this.getWeatherInfo(); //气温
            this.tNum();
            this.compitem();
            this.stateTion()
            this.Fhl();
            this.getdaily();
            //6月3日注册移入移出事件
            // this.homeitemclick();
            // this.timer = setInterval(() => {
            //     this.Jkfhl();
            // }, 60000);
        },
        updated() {
            this.Fhl();
        },
        beforeDestroy() {
            this.$store.commit("fomeall", null);
            //黎威6月15日注销
            // this.$store.commit("setData", 0);
            // this.$store.commit("Dclick", 1);
            //console.log('销毁定时器')
            // if (this.timer) {
            //     clearInterval(this.timer);
            // }
        },
        components: {
            Switchsite,
            Details,
            Overviewitemcomponents,
            ThreeOrone,
            TotalAll,
        },

        methods: {
            async getdaily() {
                let response = await diagramdaily(this.$store.state.homeitem.areaId);
                this.dailyobj = response.data.data.influxData.data.res;
            },
            async influxdbDataLoadInit() {
                let response = await influx_workload(this.currentLoop.loopId);
                this.influxDataLoad = response.data.data.influxData.data.res;
            },
            stateTion() {
                // console.log(this.$store.getters.mqttVal(this.mqqttwo + "/PF"))
                if (this.$store.getters.mqttVal(this.mqqttwo + "/PF") < 0.5) {
                    this.$set(this.state.one, 0, {
                        id: 1,
                        class: "功率因数",
                        data: "/PF", //对
                        sign: "",
                        backg: "差",
                    })

                } else if (this.$store.getters.mqttVal(this.mqqttwo + "/PF") < 0.9) {
                    this.$set(this.state.one, 0, {
                        id: 1,
                        class: "功率因数",
                        data: "/PF", //对
                        sign: "",
                        backg: "良",
                    })
                } else {
                    this.$set(this.state.one, 0, {
                        id: 1,
                        class: "功率因数",
                        data: "/PF", //对
                        sign: "",
                        backg: "优",
                    })
                }
            },

            //变压器台数
            howtall() {
                this.id = this.$store.state.project.currentProject.projectId;
                chainIndex.transformer(1, this.id).then((res) => {
                    this.transformerNum = res.data.data.devices.length;
                });
            },
            //初期渲染订阅
            fomeitem(val) {
                // console.log(this.$store.state.homeitem.from)
                this.values = val ? val : this.$store.state.homeitem.from;
            },
            // Alljack(val) {
            //   console.log(this.tobobos)
            //   this.tobobos = val;
            // },
            //负荷率公式
            Fhl() {
                let _this = this
                this.id = this.$store.state.project.currentProject.projectId;
            
                chainIndex.bianyaqiSite(_this.$store.state.homeitem.areaId).then((res=>{
    
                    let data = res.data.data.res ? res.data.data.res : "--"
                    _this.transformerCapacity = data
                }))
                // this.transformerCapacity = this.$store.state.homeitem.all.ip;

                //电压等级
                this.breaker = this.$store.state.homeitem.all.dis;
                //进线断路器
                this.areated = this.$store.state.homeitem.areaId ?
                    this.$store.state.homeitem.areaId :
                    0;
                // console.log(this.areated);
                chainIndex.breaker(this.areated).then((res) => {
                    if (res.data.data) {
                        this.voltageClasses1 = res.data.data.result[0];
                        this.voltageClasses2 =
                            res.data.data.result[1]
                    }
                });
            },
            //天气
            getWeatherInfo() {
                GetSensor(this.$store.state.homeitem.areaId).then((res) => {
                    // console.log(res.data);
                    if (res.data.data.loop) {
                        this.loopId = res.data.data.loop.loopId;
                        this.deviceName = res.data.data.loop.subLoopUrl;
                        // this.getCharData();
                        subscribeEnvironmentInfo(this.deviceName);
                    } else {
                        this.loopId = 1;
                        this.deviceName = "";
                        // this.getCharData();
                        subscribeEnvironmentInfo(this.deviceName);
                    }
                });
            },
            transformer(val) {
                this.num = val;
                // console.log(val);
            },
            tNum(val) {
                this.num = val;
                // console.log(val);
            },

            //某个样式移入移出
            homeitemclick() {
                this.homeitemall = 1;
                this.Ioimg = require("../../../assets/img/蓝色返回.png");
            },
            homeitemclickout() {
                this.homeitemall = 0;
                this.Ioimg = require("../../../assets/img/返回园区总览.png");
            },
            compitem(val) {
                this.mqqttwo = val;
                //负荷不平衡公式
                let ua = isNaN(
                        Number.parseFloat(this.$store.getters.mqttVal(this.mqqttwo + "/Ua"))
                    ) ?
                    0 :
                    Number.parseFloat(this.$store.getters.mqttVal(this.mqqttwo + "/Ua"));
                let ub = isNaN(
                        Number.parseFloat(this.$store.getters.mqttVal(this.mqqttwo + "/Ub"))
                    ) ?
                    0 :
                    Number.parseFloat(this.$store.getters.mqttVal(this.mqqttwo + "/Ub"));
                let uc = isNaN(
                        Number.parseFloat(this.$store.getters.mqttVal(this.mqqttwo + "/Uc"))
                    ) ?
                    0 :
                    Number.parseFloat(this.$store.getters.mqttVal(this.mqqttwo + "/Uc"));
                if (ua == 0 && ub == 0 && uc == 0) {
                    // console.log(mean, max, min, load, this.mqqttwo);
                    this.$set(this.state.one, 3, {
                        id: 4,
                        class: "负荷不平衡",
                        nodata: "--",
                        sign: "%",
                    });
                } else {
                    let average = (ua + ub + uc) / 3;
                    let max = Math.max(ua, ub, uc);
                    let min = Math.min(ua, ub, uc);

                    let load = average === 0 ?
                        0 :
                        (((max - min) * 100) / max).toFixed(2).replace(/[.]?0+$/, "");
                    // console.log(mean, max, min, load, this.mqqttwo);
                    this.$set(this.state.one, 3, {
                        id: 4,
                        class: "负荷不平衡",
                        nodata: load,
                        sign: "%",
                    });
                }
            },
            ...mapMutations(["setData", "getData"]),
            toAll() {
                this.areaId = this.$store.state.project.currentProject.projectId;

                this.$store.commit("setData", this.ck);
                this.$store.commit("Dthere", 1);
                chainIndex.site(this.areaId).then((res) => {
                    this.seat = res.data.data.areas[0].areaId;
                    this.$store.commit("webId", null);
                    this.$store.commit("projectid", "PROJECT_ID");
                });
            },
        },
    };
</script>
<style lang="less" scoped>
/deep/.el-dropdown-link{
    font-size: 18rem !important;
}
    #right {
        float: left;
        margin-left: 8rem;
        // background-color: rgba(0, 43, 102, 0.04);

        // background-color: #fff;
        #switchingroom {
            .w(528);
            .h(372);
            padding: 48rem 44rem 0 24rem;
            margin-bottom: 8rem;
            background-color: #ffffff;

            #oC {
                .w(120);
                white-space: nowrap;
                display: flex;
                justify-content: space-between;
                margin-bottom: 35rem;
                color: rgba(0, 43, 102, 0.6);
                font-size: 18rem;

                div {
                    // font-size: 14rem;
                    margin-left: 25rem;
                }

                p {
                    margin-left: 0rem;
                    // font-size: 14rem;
                }
            }

            .right-title {
                display: flex;
                justify-content: space-between;

                .el-button {
                    .w(137);
                    .h(32);
                    margin-top: 38rem;
                    font-size: 18rem;
                    text-align: center;
                    padding: 4rem 0;
                }
            }

            #siteswitch {
                .w(386);
                background-color: #ffffff;
                margin-bottom: 25rem;
                display: flex;

                #head {
                    .w(64);
                    .h(64);
                    background-color: #ffffff;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                #title-name {
                    font-size: 36rem;
                    font-weight: bold;
                    color: #333333;
                    margin-top: -8rem;
    max-width: 19vw;
                    margin-left: 10rem;
                    margin-bottom: 0rem;
                    white-space: nowrap
                }

                // #site {
                //   margin-top: 12rem;
                //   font-size: 16rem;
                //   margin-top: 0rem;
                //   margin-left: 16rem;
                // }
            }

            #electricquantity {
                .w(460);

                #one {
                    .w(460);
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 20rem;

                    .one-item {
                        font-size: 18rem;
                    }
                }

                #two {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    padding-right: 18rem;

                    .two-item {
                        font-size: 18rem;
                    }
                }
            }
        }

        #runningstatus {
            .w(528);
            .h(260);
            padding: 23rem 24rem 0 24rem;
            margin-bottom: 8rem;
            background: #ffffff; 

            #title {
                margin-bottom: 20rem;
                font-size: 18rem;
                // color: #333333;
            }

            #state {
                width: 100%;

                // margin-bottom: 10rem;
                #state-one {
                    display: flex;
                    justify-content: space-between;
                    // margin-bottom: 30rem;
                    // margin-top: 20rem;
                }

                #state-two {
                    display: flex;
                    justify-content: space-between;
                }
            }

            #communication {
                font-size: 16rem;
                // color: #6666;
            }
        }

        .temperature2 {
            font-size: 18rem;
            margin-top: 20rem;
            color: #666666;
            white-space: nowrap;
            display: flex;
            //  justify-content: space-between;
            width: 100%;

            .temperature-item2 {
                width: 79%;
                display: flex;
                justify-content: space-between;
                margin-left: 7%;
                color: #333333;

                .clay {
                    width: 25%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-weight: bold;

                    p {
                        margin-left: 3rem;
                        // margin-top: 1rem;
                        text-align: center;
                        line-height: 24rem;
                        font-size: 14rem;
                    }
                }
            }

            .temperature-item4 {
                //  width: 79%;
                display: flex;
                // justify-content: space-between;
                margin-left: 5%;
                color: #333333;

                .clay {
                    width: 25%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-weight: bold;

                    p {
                        margin-left: 3rem;
                        // margin-top: 1rem;
                        text-align: center;
                        line-height: 24rem;
                        font-size: 14rem;
                    }
                }
            }
        }

        .temperature1 {
            width: 100%;
            font-size: 18rem;
            margin-top: 25rem;
            color: #666666;
            white-space: nowrap;
            display: flex;

            .temperature-item1 {
                width: 79%;
                display: flex;
                justify-content: space-between;
                margin-left: 7%;
                color: #333333;

                .clay {
                    width: 25%;
                    display: flex;
                    align-items: center;
                    font-weight: bold;

                    p {
                        margin-left: 3rem;
                        margin-top: 2rem;
                        text-align: center;
                        line-height: 24rem;
                        font-size: 14rem;
                    }
                }
            }
        }

        .temperature {
            // display: flex;
            // width: 1000rem;
            font-size: 18rem;
            margin-top: 40rem;
            color: #666666;
            white-space: nowrap;

            .checkabc {
                width: 79%;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .temperature-item {
                    white-space: nowrap;
                    // margin-top: 3rem;
                    padding-left: 18rem;
                    width: 25%;
                    // margin-left: 20rem;
                    display: flex;
                    align-items: center;
                    // justify-content: space-between;
                    // text-align: right;
                    // padding-right: 20rem;
                    color: #333333;
                    font-weight: bold;

                    h5 {
                        white-space: nowrap;
                    }

                    div {
                        font-weight: 900;
                        font-size: 14rem;
                        margin-top: 1rem;
                        margin-left: 2rem;
                    }
                }
            }
        }
    }

    #list {
        display: flex;
        justify-content: space-between;
    }

    .record-item {
        font-size: 18rem;
        font-weight: 400;
        color: #666666;
        display: flex;
        align-items: center;
    }

    .record-op {
        margin-top: 12rem;
        font-size: 21rem;
        justify-content: center;
        display: flex;
        align-items: center;
        font-weight: 900;

        .data {
            font-size: 18rem;
        }

        #nbsp {
            margin-left: 5rem;
            font-size: 10rem;
        }

        span {
            margin-top: -1rem;
            margin-left: 3rem;
            font-size: 12rem;
        }
    }

    .record-st {
        margin-top: 10rem;
        font-size: 21rem;
        text-align: center;
        font-weight: bold;

        span {
            font-size: 12rem;
        }
    }

    .clickfalls {
        display: flex;
        align-items: center;
    }

    .tran {
        font-size: 21rem;
        color: #666666;
    }

    .chen {
        font-size: 16rem !important;
    }

    .itemBtn {
        padding: 12rem 12rem !important;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            .w(14);
            .h(14);
        }
    }
</style>